import { SelectItemViewModel } from "shared/ui-kit/SelectComponent";
import { EtfBackendViewModel, FieldValuesByCurrency } from "./backend";

export interface IReturnMapDataSources {
	currencies: {
		items: SelectItemViewModel[];
	};
	colors: {
		items: SelectItemViewModel[];
		valueProviderByKey: {
			[key: string]: (values: FieldValuesByCurrency) => number | null;
		}
	};
	sizes: {
		items: SelectItemViewModel[];
	};
	tradeStatuses: {
		items: SelectItemViewModel[];
	};
	groups: {
		items: SelectItemViewModel[];
		attributeProdivderByKey: {
			[key: string]: (etf: EtfBackendViewModel) => string;
		}
	}
}

export const defaultDataSources: IReturnMapDataSources = {
	currencies: {
		items: [
			{ key: 'RUB', text: 'RUB' },
			{ key: 'USD', text: 'USD' },
			{ key: 'EUR', text: 'EUR' }
		]
	},
	colors: {
		items: [
			{ key: '1day', text: 'Доходность за 1 день' },
			{ key: '1week', text: 'Доходность за 1 неделю' },
			{ key: '1month', text: 'Доходность за 1 месяц' },
			{ key: '3month', text: 'Доходность за 3 месяца' },
			{ key: '1year', text: 'Доходность за 1 год' }
		],
		valueProviderByKey: {
			'1day': x => x['metric/return/1day'],
			'1week': x => x['metric/return/1week'],
			'1month': x => x['metric/return/1month'],
			'3month': x => x['metric/return/3month'],
			'1year': x => x['metric/return/1year']
		}
	},
	sizes: {
		items: [
			{ key: 'assetsUnderManagement', text: 'СЧА' }
		]
	},
	groups: {
		items: [
			{ key: 'assetClass', text: 'Класс активов' },
			{ key: 'assetSubClass', text: 'Категория активов' },
			{ key: 'assetCurrency', text: 'Валюта активов' },
			{ key: 'region', text: 'Регион' },
			{ key: 'country', text: 'Страна' },
			{ key: 'markerType', text: 'Рынок' },
			{ key: 'issuer', text: 'Управляющая компания' }
		],
		attributeProdivderByKey: {
			'assetClass': etf => etf.tags.investmentPolicy.assetClass,
			'assetSubClass': etf => etf.tags.investmentPolicy.assetSubClass,
			'assetCurrency': etf => etf.tags.investmentPolicy.assetCurrency,
			'region': etf => etf.tags.geography.area,
			'country': etf => etf.tags.geography.country,
			'markerType': etf => etf.tags.geography.marketType,
			'issuer': etf => etf.issuer.name
		}
	},
	tradeStatuses: {
		items: [
			
		]
	}
}